<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-4">
<div class="heading heading-with-title heading-without-image" id="chapter-4-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">4</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-4-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">I</span>t wasn’t a dog walker or a jogger that found the body. It was two teenagers looking for a golf ball.</p>
<p class="subsq">Deano and Chippy had set off early to walk to the playing fields in Darmont, down past the old church and village pond. When they got there, a sign at the entrance warned them golf practice wasn’t allowed on the playing fields. They ignored it and carried on to the far end beyond the football pitch.</p>
<p class="subsq">Chippy looked anxiously back towards the village hall. ‘You see the car up there?’</p>
<p class="subsq">‘Yeah, why?’</p>
<p class="subsq">‘Can’t see anyone about. Think someone’s in the hall? Don’t want to get caught playing golf.’</p>
<p class="subsq">‘Nah. It’s Saturday. There won’t be anyone there.’</p>
<p class="subsq">Chippy was still uneasy. ‘So where are they?’</p>
<p class="subsq">‘Look, if you’re worried about playing, why didn’t you say so before we walked all the way down here?’</p>
<p class="subsq">‘Sorry, Deano. Didn’t think.’</p>
<p class="subsq">Deano slapped Chippy on the back. He’d given his friend the nickname due to his love of chips, not because of his dubious skill at chipping a golf ball. ‘Don’t worry, mate,’ he said, setting his golf bag down on the grass and pulling out a driver. ‘They might have parked there to take a dog for a walk down by the woods. It won’t be anyone official.’</p>
<p class="subsq">‘Okay. You’re not going to use that thing here, are you?’ Chippy asked.</p>
<p class="subsq">‘Yeah, why not? I won’t hit it too far.’</p>
<p class="subsq">Both boys had grown up in the village. It was a scenic place, off the beaten track with a population of around three thousand. No main roads passed through, just a network of narrow country lanes. There was a railway station which also served a local town five miles away. It was a direct line into London and you could be there in under an hour.</p>
<p class="subsq">The Horse and Hounds pub was a popular eating place, while the Down Inn was more a traditional locals’ pub. Villagers raved about the quality of meat and pies sold by the local butcher. The post office also served as a small convenience store. A medical practice sat in the centre of the village.</p>
<p class="subsq">Deano bent down, stuck a long wooden tee in the grass, and placed a worn-looking golf ball on top.</p>
<p class="subsq">‘Bet you overhit it,’ Chippy said.</p>
<p class="subsq">Deano stood up and took a practice swing with his club. ‘Watch and learn.’</p>
<p class="subsq">He stood back from the ball, keeping it in line with the inside of his left foot and took a slow swing back. Unleashing the club with all his might he smashed it into the ball. It lifted into the air. Both boys watched as it veered to the right and dropped into the trees on the edge of the playing field.</p>
<p class="subsq">‘You see that?’ Deano said. ‘Must have hit it over a hundred and fifty yards!’</p>
<p class="subsq">‘Yeah,’ Chippy agreed, ‘but hardly a straight line. Doubt we’ll find it.’</p>
<p class="subsq">‘Let’s go look.’</p>
<p class="subsq">Chippy giggled. ‘Hope there isn’t someone walking a dog in there. Might find a dead body with your ball next to it.’</p>
<p class="subsq">‘Ha, ha, very funny.’</p>
<p class="subsq">The boys left their golf bags where they were and set off to look for the ball.</p>
<p class="subsq">‘Think I got a line on it,’ Deano said. ‘Came in about here.’</p>
<p class="subsq">‘Nah, much further to the right. Something wrong with your eyesight, mate,’ Chippy said, disappearing into the trees.</p>
<p class="subsq">‘Course,’ Deano shouted, ‘once it hit a tree, it could have bounced anywhere.’</p>
<p class="subsq">‘Yeah, yeah. If I find it over here, you’ll say it was deflected.’</p>
<p class="subsq">Deano heard Chippy thrashing a club about in the bushes. Suddenly there was silence, then the sound of running feet.</p>
<p class="subsq">Chippy appeared from behind a bush, ashen-faced.</p>
<p class="subsq">Deano frowned. ‘You find it?’</p>
<p class="subsq">‘Bloody hell, Deano, you’ve killed someone!’</p>
<p class="subsq">Deano’s mouth dropped open. ‘Stop fucking about, Chippy. Not funny.’</p>
<p class="subsq">‘I’m not… not joking! There’s a man lying under a bush. Oh, God, we’re right in the shit now!’</p>
<p class="subsq">Deano’s eyes widened and the colour drained from his face. ‘Where?’</p>
<p class="subsq">Chippy turned. ‘Over here.’</p>
<p class="subsq">Deano followed him a few yards into the undergrowth. He saw the feet first and pushed the bushes to one side to reveal the rest of the body. After breathing out a sigh of relief that it wasn’t his golf ball which had caused the damage, he vomited.</p>
<p class="subsq">Chippy stood there helpless.</p>
<p class="subsq">When Deano had stopped throwing up, he looked wide-eyed at Chippy. ‘It wasn’t my golf ball that put two holes in his head. He’s been shot.’</p>
<p class="subsq">Chippy was shaking. His eyes darted from side to side as though expecting someone with a gun to appear out of the bushes. ‘Wha… what!’</p>
<p class="subsq">Deano had recovered his senses and was pulling his mobile out of his pocket to dial 999.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter-004.vue?9cb47cea